<template>
  <div class="container">

    <div v-if="errors" class="alert alert-danger">
      <div>Please check the following errors.</div>
      <ul class="mb-0 pl-4 small">
        <template v-for="error_group in errors">
          <li :key="k" v-for="(error,k) in error_group">{{ error }}</li>
        </template>
      </ul>
    </div>

    <div class="row">
      <div class="col-md-4 offset-md-4">

        <div class="text-center py-4">
          <img :src="logo" style="height:80px">
        </div>

        <div class="card border-0 shadow-sm">
          <div class="card-body">

            <form @submit.prevent="attemptLogin">
              <div class="form-group">
                <label for="input-login-email">Email address</label>
                <input type="email" name="email" v-model="email" class="form-control" id="input-login-email" required
                       autofocus>
              </div>
              <div class="form-group">
                <label for="input-login-password">Password</label>
                <input type="password" name="password" v-model="password" @keypress.enter="attemptLogin"
                       class="form-control" id="input-login-password" required>
              </div>
              <div class="mb-3">
                <a :href="adminEndpoint + '/password/reset'">Forgot password?</a>
              </div>
              <button class="btn btn-primary" :disabled="processing">
                <template v-if="processing">
                  <i class="fas fa-circle-notch fa-spin"></i>
                </template>
                Login
              </button>
            </form>

          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  data () {
    return {
      logo: process.env.URL_LOGO,
      adminEndpoint: process.env.URLS_ADMIN,
      email: null,
      password: null,
      processing: false,
      errors: null
    }
  },
  methods: {
    attemptLogin () {
      if (!this.email) {
        this.$toast.error('Please provide your e-mail address.')
        return false
      }

      if (!this.password) {
        this.$toast.error('Please provide the password.')
        return false
      }

      this.processing = true
      this.errors = null

      axios.post(process.env.URLS_POS_API + '/auth/login', {
        email: this.email,
        password: this.password
      }).then((response) => {
        if (typeof response.data.data.api_token === 'undefined') {
          this.processing = false
          this.$toast.error('Failed to obtain a valid token.')
          return false
        }

        this.$store.dispatch('authenticationSuccess', response.data.data)
        this.$toast.success('You have successfully signed in!')
        // this.$router.push({ name: 'stores' })
        document.location.href = '/stores'
      }).catch(error => {
        this.processing = false

        let errorMessage = 'Failed to process your login.'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage += ' ' + error.response.data.message
        }
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null
        this.$toast.error(errorMessage, errorDescription)

        this.errors = error.response.data.errors || null
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue